import React, { useCallback, useState } from 'react';
import { type FAQItem } from '@lib/content';

interface FaqAccordionProps {
  faqs: FAQItem[];
}

const FaqAccordion: React.FC<FaqAccordionProps> = ({ faqs }) => {
  const [openIndices, setOpenIndices] = useState<Set<number>>(() => new Set());

  const toggle = useCallback((index: number) => {
    setOpenIndices((prev) => {
      const next = new Set(prev);
      if (next.has(index)) {
        next.delete(index);
      } else {
        next.add(index);
      }
      return next;
    });
  }, []);

  return (
    <div className="faq-accordion">
      {faqs.map((faq, index) => {
        const isOpen = openIndices.has(index);
        const triggerId = `faq-trigger-${index}`;
        const panelId = `faq-panel-${index}`;

        return (
          <div key={index} className="faq-accordion__item">
            <h3 className="faq-accordion__header">
              <button
                type="button"
                id={triggerId}
                className={`faq-accordion__trigger${isOpen ? ' is-open' : ''}`}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => toggle(index)}
              >
                <span className="faq-accordion__question">{faq.question}</span>
                <span className="faq-accordion__icon" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </span>
              </button>
            </h3>
            <div
              id={panelId}
              role="region"
              aria-labelledby={triggerId}
              aria-hidden={!isOpen}
              className={`faq-accordion__panel${isOpen ? ' is-open' : ''}`}
            >
              <div className="faq-accordion__answer">
                <p>{faq.answer}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FaqAccordion;
